import { utcFormat } from 'd3-time-format';
import { toCurrency } from '@/utilities/formatting';
import { cn } from '@simplywallst/ui-core/next';

const formatDate = utcFormat('%a, %e %b %y');

interface PriceChartHeaderProps {
  width: number;
  currentX: number;
  currentDate?: Date;
  currentClose?: number | null;
  currencyISO: string;
}

const PriceChartHeader = ({
  width,
  currentX,
  currentDate,
  currentClose,
  currencyISO,
}: PriceChartHeaderProps) => {
  const flip = currentX < width / 2;

  return (
    <div
      className="pointer-events-none absolute"
      style={{
        transform: `translateX(${currentX - (flip ? 0.5 : -0.5) || 0}px)`,
      }}
    >
      <div
        className={cn(
          'absolute right-0 min-w-[18ch] bg-[--chart-header-bg] px-3 py-2 text-center',
          flip && 'left-0 right-auto'
        )}
      >
        <div className="whitespace-nowrap text-sm font-bold leading-none">
          {currentClose
            ? toCurrency(currentClose, 2, currencyISO)
            : `No trading data`}
          <br />
        </div>
        {currentDate && (
          <div className="mt-1 whitespace-nowrap text-tiny leading-none text-soft">
            {formatDate(currentDate)}
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceChartHeader;
